import React, { useEffect } from "react";
import "./modalslidebottom.css";

export default function ModalSlideBottom({
  open,
  title,
  onClose,
  children,
  footer,
}) {
  useEffect(() => {
    if (!open) return;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleEscape);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", handleEscape);
    };
  }, [open, onClose]);

  return (
    <div className={`sb-root ${open ? "open" : ""}`} aria-hidden={!open}>
      <div className="sb-backdrop" onClick={onClose} />

      <section
        className="sb-panel"
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <header className="sb-header">
          <h3>{title}</h3>

          <button
            type="button"
            className="sb-close"
            onClick={onClose}
            aria-label="Close"
          >
            ✕
          </button>
        </header>

        <div className="sb-body">{children}</div>

        {footer && <footer className="sb-footer">{footer}</footer>}
      </section>
    </div>
  );
}
